import React, { useEffect, useState } from "react"
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap"
import FullCalendar from "@fullcalendar/react"
import dayGridPlugin from "@fullcalendar/daygrid"
import interactionPlugin, { Draggable } from "@fullcalendar/interaction"
import BootstrapTheme from "@fullcalendar/bootstrap"
import editEventImg from "../../../../assets/images/Digital Marketing/editEventImg.jpg"
import secureLocalStorage from "react-secure-storage"
import {
  fetchData,
  fetchNodeData,
  FetchNodePostData,
  FetchPostData,
} from "utils/common-fetchData"
import moment from "moment"
import Loader from "pages/Separate/Loader"
import {
  addTimes,
  adjustTime,
  calculateQtyWithinTime,
  calculateTotalTime,
  convertToMinutes,
  FilteredArray,
  getInitials,
  getNextMonthStartEnd,
  minutesToTime,
  updateTimeForDate,
} from "utils/common-helpers"
import Swal from "sweetalert2"
import Breadcrumb from "components/Common/Breadcrumb"
import bug from "../../../../assets/images/flags/bug-icon.png"
import Suggestion from "../../../../assets/images/flags/sugg-icon.png"
import Select from "react-select"
import { colourStyles, TimeOption } from "utils/common-options"
import { allElements } from "utils/elements/element-config"
import { useNavigate } from "react-router-dom"
import configure from "configure"
import { useSelector } from "react-redux"

const TicketPlanning = () => {
  document.title = "Monthly Planning | Zithas Crm"
  const [activities, setActivities] = useState([])
  const [filterActivities, setFilterActivities] = useState([])
  const [allActivities, setAllActivities] = useState([])
  const [allPlanned, setAllPlanned] = useState([])
  const [activityName, setActiviyName] = useState("")
  const [projectId, setProjectId] = useState([])
  const [service, setService] = useState([])
  const [isDragging, setIsDragging] = useState(false)
  const [searchValue, setSearchValue] = useState("")
  document.addEventListener("keydown", e => {
    if (e.key == "Escape") {
      if (modal) {
        setModal(false)
      }
    }
  })

  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [eventsList, setEvents] = useState([])
  const [modalData, setModalData] = useState({})
  const [eventData, setEventData] = useState({})
  const [qty, setQty] = useState("")
  const [addModal, setAddModal] = useState(false)
  const [changeKey, setChangeKey] = useState(false)

  useEffect(() => {
    new Draggable(document.getElementById("external-events"), {
      itemSelector: ".external-event",
    })
  }, [])

  const handleEventClick = info => {
    setModalData({
      id: info?.event?.extendedProps.ticket_id,
      start_date: moment(info?.event?.start).format("YYYY-MM-DD"),
      live_date: moment(info?.event?.extendedProps?.live_date).format(
        "YYYY-MM-DD"
      ),
      estimated_time: info?.event?.extendedProps?.estimated_time,
      timeTaken: info?.event?.extendedProps?.support_time,
    })
    setActiviyName(info?.event?.title)
    setAddModal(true)
  }

  const onDrag = event => {
    event.preventDefault()
  }

  const onDrop = async event => {
    const { date, draggedEl } = event
    if (!draggedEl || !draggedEl.classList.contains("external-event")) return

    const categoryId = draggedEl.id
    const quantity = draggedEl.getAttribute("data-quantity") || 1
    const estTime = draggedEl.getAttribute("data-est") || "00:00"
    const type = draggedEl.getAttribute("type") || 0

    const formattedDate = moment(date).format("YYYY-MM-DD")

    const newEvent = {
      title: draggedEl.innerText || draggedEl.getAttribute("title"),
      start: date,
      id: categoryId,
      quantity: quantity,
      est_time: estTime,
      actual_time: calculateTotalTime(estTime, quantity),
      occupied: "00:00",
    }

    const formEntries = {
      id: categoryId,
      task_id: categoryId,
      staff_id: localStorage.getItem("auth_id"),
      project_id: projectId?.value,
      activity_id: categoryId,
      type: service?.value,
      quantity: quantity,
      start_date: formattedDate,
      user_id: localStorage.getItem("auth_id"),
      className: draggedEl.className,
    }

    setActiviyName(draggedEl.innerText || draggedEl.getAttribute("title"))
    setQty(quantity)
    setModalData(formEntries)
    setEventData(newEvent)
    setAddModal(true) // Open popup
  }

  const [customDateHtml, setCustomDateHtml] = useState([])
  const [isLoading, setLoading] = useState(false)
  const token = secureLocalStorage.getItem("auth_id")
  const [isShow, setIsShow] = useState(null)
  const toggleLoading = load => {
    setLoading(load)
  }

  const onGetActivities = async () => {
    const res = await fetchNodeData(
      toggleLoading,
      `earthTicketsPlanning`,
      token
    )
    if (res?.status === 200) {
      const planned =
        res?.data?.planned_tickets?.filter(
          obj => obj?.status != 5 && obj?.status != 4
        ) || []
      const unplanned = res?.data?.unplanned_tickets || []

      setAllActivities(unplanned)
      setActivities(unplanned)
      setFilterActivities(unplanned)

      const plannedEvents = planned.map(obj => ({
        title: obj.subject,
        start: moment(obj.date).format("YYYY-MM-DD"),
        id: obj.id,
        ticket_id: obj.ticket_id,
        est_time: obj.estimated_time,
        description: obj.description,
        project_id: obj.project_id,
        added_by: obj.added_by,
        checked: obj.checked,
        classNames: [
          obj?.type == 0 ? "bg-seo text-white" : "bg-ppc text-white",
          obj?.checked == 1 ? "checked-event" : "",
        ],

        editable: true,
        ...obj,
      }))

      setEvents(plannedEvents)
      setAllPlanned(plannedEvents)
    }
  }
  const navigate = useNavigate()
  const assignElement = useSelector(state => state?.Elements?.element)

  useEffect(() => {
    const elements = assignElement?.split(",")
    const isExist = elements?.includes("23")
    if (!isExist) {
      navigate(`${configure.appUrl}access-denied`)
    }
    onGetActivities()
  }, [])

  const onDragEdit = async (info, oldStart) => {
    setModalData({
      id: info?.extendedProps.ticket_id,
      start_date: moment(info?.start).format("YYYY-MM-DD"),
      live_date: moment(info?.extendedProps?.live_date).format("YYYY-MM-DD"),
      estimated_time: info?.extendedProps?.estimated_time,
    })
    setAddModal(true)
  }

  const onPlanTicket = async () => {
    if (
      !modalData?.id ||
      !modalData?.start_date ||
      !modalData?.estimated_time
    ) {
      Swal.fire({
        icon: "warning",
        title: "⚠️ Please fill all required fields!",
      })
      return
    }

    const postData = {
      id: modalData?.id,
      date: modalData?.start_date,
      live_date: modalData?.live_date || null,
      estimated_time: modalData?.estimated_time,
    }

    const res = await FetchNodePostData(
      toggleLoading,
      "earthTicketsPlanning",
      token,
      postData
    )
    if (res?.data?.status == 200) {
      Swal.fire({
        icon: "success",
        title: "Ticket Planned Successfully!",
      })
      setAddModal(false)
      onGetActivities()
    } else {
      Swal.fire({
        icon: "error",
        title: "❌ Failed to Plan Ticket",
        text: res?.data?.message || "Please try again.",
      })
    }
  }
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false)

  const handleChecked = async (id, checked) => {
    const result = await Swal.fire({
      icon: "warning",
      title:
        checked == 0
          ? "Are you sure you want to mark this ticket as tested?"
          : "Are you sure you want to unmark this ticket as tested?",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    })

    if (result.isConfirmed) {
      console.log("api called")

      const response = await FetchNodePostData(
        toggleLoading,
        "earthTicketsPlanning/checked",
        secureLocalStorage.getItem("auth_token"),
        {
          id: id,
          user: localStorage.getItem("auth_id"),
        }
      )

      console.log("response: ", response)

      if (response?.success || response?.data?.success) {
        console.log("success: ", response)
        onGetActivities()
      }
    }
  }

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <div className="page-content mb-4">
        <Container fluid>
          <Breadcrumb
            title="Ticket Planning"
            breadcrumbItem="Earth ZAI Ticket"
          />
          <Row>
            <Col lg={12} className="p-0">
              <Card>
                <CardBody>
                  <div className="">
                    <Row>
                      <Row className="pt-2 p-0">
                        <Col lg={sidebarCollapsed ? 1 : 4}>
                          <Card>
                            <div className="pt-0">
                              <div
                                id="external-events"
                                className="mt-0"
                                style={{
                                  height: "860px",
                                  overflowY: "auto",
                                  scrollbarWidth: "thin",
                                  scrollbarColor: "#8796ce #f0f0f0",
                                }}
                              >
                                <div className="search-box mb-3 me-2 ms-2">
                                  {!sidebarCollapsed ? (
                                    <>
                                      <input
                                        id="search-bar-0"
                                        type="text"
                                        className="s form-control rounded "
                                        style={{ width: "90%" }}
                                        placeholder=" Search Tickets  ..."
                                        onChange={e => {
                                          setSearchValue(e.target.value)
                                          const searchValue =
                                            e.target.value.toLowerCase()
                                          const filteredActivities =
                                            filterActivities.filter(
                                              activity =>
                                                activity.subject
                                                  ?.toLowerCase()
                                                  .includes(
                                                    searchValue.toLowerCase()
                                                  ) ||
                                                String(activity?.id).includes(
                                                  searchValue
                                                )
                                            )
                                          setActivities(filteredActivities)
                                        }}
                                        value={searchValue}
                                      />

                                      <span>
                                        <i className="bx bx-search-alt search-icon ms-2"></i>
                                      </span>

                                      <i
                                        className="bx bx-x-circle search-icon ms-2 text-danger cursor-pointer"
                                        onClick={() => {
                                          setSearchValue("")
                                          setActivities(filterActivities)
                                        }}
                                        style={{ left: "80%" }}
                                      ></i>
                                    </>
                                  ) : null}

                                  <a className="">
                                    <i
                                      className="bi bi-list search-icon ms-2 text-white cursor-pointer btn-purple px-2 rounded"
                                      onClick={() => {
                                        setSidebarCollapsed(!sidebarCollapsed)
                                      }}
                                      style={{
                                        left: sidebarCollapsed ? "30%" : "90%",
                                      }}
                                    ></i>
                                  </a>
                                </div>
                                {!sidebarCollapsed && (
                                  <>
                                    {activities &&
                                      activities.map((category, i) => {
                                        return (
                                          <div
                                            className="d-flex justify-space-between align-items-center"
                                            key={i}
                                          >
                                            <div
                                              className={` external-event fc-event text-white w-100 d-flex justify-space-between align-items-center`}
                                              id={category?.id}
                                              draggable
                                              onDrag={event =>
                                                onDrag(event, category)
                                              }
                                            >
                                              <span>
                                                {category?.id} -{" "}
                                                {category.subject}
                                              </span>
                                              <span>
                                                <img
                                                  src={
                                                    category?.type == 0
                                                      ? bug
                                                      : Suggestion
                                                  }
                                                  alt="No Img"
                                                  width={20}
                                                  height={20}
                                                />
                                              </span>
                                            </div>
                                          </div>
                                        )
                                      })}

                                    {activities?.length == 0 && (
                                      <p className="text-center text-purple fw-bold mt-3">
                                        🎉 All pending Tickets have been planned
                                        for future! <br />
                                      </p>
                                    )}
                                  </>
                                )}
                              </div>
                            </div>
                          </Card>
                        </Col>
                        <Col
                          lg={sidebarCollapsed ? 11 : 8}
                          className="pe-0 ps-0"
                        >
                          <div className="show-date">
                            <FullCalendar
                              key={changeKey}
                              plugins={[
                                BootstrapTheme,
                                dayGridPlugin,
                                interactionPlugin,
                              ]}
                              slotDuration={"00:15:00"}
                              handleWindowResize={true}
                              initialView="dayGridWeek"
                              themeSystem="bootstrap"
                              weekends={true}
                              headerToolbar={{
                                left: "prev,next today",
                                center: "title",
                                right: "dayGridMonth,dayGridWeek,dayGridDay",
                              }}
                              events={eventsList}
                              eventContent={arg => {
                                const { event } = arg
                                console.log(event?.extendedProps)
                                const id =
                                  event.extendedProps?.ticket_id || event.id
                                return (
                                  <div className="d-flex flex-column justify-content-start align-items-start">
                                    <div className="d-flex gap-1 align-items-center w-100 mb-2">
                                      {event.extendedProps.avatar ? (
                                        <img
                                          src={`${configure.imgUrl}${event.extendedProps.avatar}`}
                                          alt="Icon"
                                          className="me-1"
                                          title={
                                            event.extendedProps?.alias_name
                                          }
                                          style={{
                                            width: "20px",
                                            height: "20px",
                                            borderRadius: "50%",
                                          }}
                                        />
                                      ) : (
                                        <span
                                          className="defualt-img ml-1"
                                          style={{
                                            width: "20px",
                                            height: "20px",
                                          }}
                                          title={
                                            event.extendedProps?.alias_name
                                          }
                                        >
                                          {getInitials(
                                            event.extendedProps?.alias_name
                                          )}
                                        </span>
                                      )}
                                      <div className="font-size-11 text-purple fw-bold">
                                        Live :{" "}
                                        {moment(
                                          event?.extendedProps?.live_date
                                        ).format("DD MMM")}
                                      </div>
                                      {localStorage.getItem("auth_id") == 1 ||
                                      localStorage.getItem("auth_id") == 144 ? (
                                        <a
                                          title="Checked"
                                          className="ms-auto"
                                          onClick={e => {
                                            e.preventDefault()
                                            setAddModal(false)
                                            handleChecked(
                                              id,
                                              event?.extendedProps.checked
                                            )
                                            return false // <--- this blocks native FC trigger completely
                                          }}
                                        >
                                          {event.extendedProps.checked == 0 ? (
                                            <i className="bi bi-circle " />
                                          ) : (
                                            <i className="bi bi-check-circle" />
                                          )}
                                        </a>
                                      ) : null}
                                    </div>
                                    <div
                                      className="text-start"
                                      style={{
                                        wordWrap: "break-word",
                                        wordBreak: "break-word",
                                        whiteSpace: "normal",
                                        maxWidth: "100%",
                                      }}
                                    >
                                      <span>
                                        <span>
                                          <img
                                            src={
                                              event?.extendedProps?.type == 0
                                                ? bug
                                                : Suggestion
                                            }
                                            alt="No Img"
                                            width={15}
                                            height={15}
                                          />{" "}
                                        </span>
                                        {id}
                                      </span>{" "}
                                      - {event.title}{" "}
                                    </div>
                                    <div
                                      className="text-start"
                                      style={{
                                        wordWrap: "break-word",
                                        wordBreak: "break-word",
                                        whiteSpace: "normal",
                                        maxWidth: "100%",
                                        marginTop: "7px",
                                      }}
                                    >
                                      <span className="fw-bold">
                                        Day's Time -
                                      </span>{" "}
                                      {event?.extendedProps?.days_time}{" "}
                                    </div>
                                    <div
                                      className="text-start"
                                      style={{
                                        wordWrap: "break-word",
                                        wordBreak: "break-word",
                                        whiteSpace: "normal",
                                        maxWidth: "100%",
                                      }}
                                    >
                                      <span className="fw-bold">
                                        Time Taken -
                                      </span>{" "}
                                      {event?.extendedProps?.support_time}{" "}
                                    </div>
                                    <div
                                      className="text-start"
                                      style={{
                                        wordWrap: "break-word",
                                        wordBreak: "break-word",
                                        whiteSpace: "normal",
                                        maxWidth: "100%",
                                      }}
                                    >
                                      <span className="fw-bold">
                                        Est. Time -
                                      </span>{" "}
                                      {event?.extendedProps?.estimated_time}{" "}
                                    </div>
                                  </div>
                                )
                              }}
                              dayCellContent={cell => {
                                const { date } = cell
                                const formattedDate =
                                  moment(date).format("YYYY-MM-DD")
                                const totalMinutes = eventsList
                                  ?.filter(
                                    activity => activity.start == formattedDate
                                  )
                                  ?.reduce((sum, activity) => {
                                    return (
                                      sum +
                                      convertToMinutes(
                                        activity.estimated_time || "00:00"
                                      )
                                    )
                                  }, 0)

                                const totalEstimatedTime =
                                  minutesToTime(totalMinutes)
                                return (
                                  <div
                                    className="fc-day-cell-content w-100 justify-space-between align-items-center"
                                    style={{ flexDirection: "initial" }}
                                  >
                                    <div className="time-header mb-0">
                                      {totalEstimatedTime} hrs
                                    </div>
                                    <div className="fc-day-number">
                                      {date.getDate()}
                                    </div>
                                  </div>
                                )
                              }}
                              editable={true}
                              droppable={true}
                              selectable={true}
                              eventClick={handleEventClick}
                              drop={onDrop}
                              eventDragStart={e => {
                                setIsDragging(true)
                                // handleEventClick(e, true)
                              }}
                              eventReceive={info => {
                                if (isDragging) {
                                  onDragEdit(info.event)
                                }
                                setIsDragging(false)
                              }}
                            />
                          </div>
                          <Modal isOpen={addModal} size="lg" centered>
                            <ModalHeader
                              toggle={() => {
                                onGetActivities()
                                setAddModal(false)
                              }}
                              tag="h5"
                              className="py-3 px-4 border-bottom-0"
                            >
                              Plan Ticket
                            </ModalHeader>
                            <ModalBody className="p-4">
                              <Form
                                onSubmit={e => {
                                  e.preventDefault()
                                  onPlanTicket()
                                }}
                              >
                                <Row>
                                  <div className="col-md-5 d-flex justify-content-end align-items-center ps-3">
                                    <div className="text-center">
                                      <img
                                        src={editEventImg}
                                        alt="Addepe"
                                        style={{ width: "90%" }}
                                      />
                                    </div>
                                  </div>

                                  <div className="col-7 d-flex flex-column justify-content-center align-items-start pl-0">
                                    <div className="mb-3 col-12">
                                      <Label className="form-label">
                                        Activity Name
                                      </Label>
                                      <Input
                                        disabled
                                        type="text"
                                        value={activityName?.replace(
                                          /\d+/g,
                                          ""
                                        )}
                                      />
                                    </div>

                                    <div className="mb-3 col-12">
                                      <Label className="form-label">
                                        Planned Date
                                      </Label>
                                      <Input
                                        type="date"
                                        className="form-control"
                                        value={modalData?.start_date || ""}
                                        onChange={e =>
                                          setModalData({
                                            ...modalData,
                                            start_date: e.target.value,
                                          })
                                        }
                                      />
                                    </div>

                                    <div className="mb-3 col-12">
                                      <Label className="form-label">
                                        Live Date
                                      </Label>
                                      <Input
                                        type="date"
                                        className="form-control"
                                        min={modalData?.start_date || ""}
                                        value={modalData?.live_date || ""}
                                        onChange={e =>
                                          setModalData({
                                            ...modalData,
                                            live_date: e.target.value,
                                          })
                                        }
                                      />
                                    </div>

                                    {/* SAME ROW */}
                                    <div className="row w-100">
                                      <div className="mb-3 col-6">
                                        <Label className="form-label">
                                          Estimated Time
                                        </Label>
                                        <Select
                                          className="basic-single"
                                          classNamePrefix="select"
                                          options={TimeOption}
                                          styles={colourStyles}
                                          value={TimeOption.find(
                                            o =>
                                              o.value ==
                                              modalData?.estimated_time
                                          )}
                                          onChange={selected =>
                                            setModalData({
                                              ...modalData,
                                              estimated_time: selected.value,
                                            })
                                          }
                                        />
                                      </div>

                                      <div className="mb-3 col-6">
                                        <Label className="form-label">
                                          Time Taken
                                        </Label>
                                        <Input
                                          type="text"
                                          className="form-control"
                                          value={modalData?.timeTaken}
                                          disabled
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </Row>

                                <Row>
                                  <Col className="col-12 text-end">
                                    <button
                                      type="submit"
                                      className="btn ms-md-2 btn-save btn-label"
                                    >
                                      <i className="fas fa-save me-1 label-icon"></i>{" "}
                                      Submit
                                    </button>
                                  </Col>
                                </Row>
                              </Form>
                            </ModalBody>
                          </Modal>
                        </Col>
                      </Row>
                    </Row>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default TicketPlanning
